let paso=1;
const pasoInicial=1;
const pasoFinal=2;
let feriados= [];
let barberos= [];
const cita= {
    id: '',
    nombre: '',
    nombreClienteAdmin: '',
    fecha: '',
    hora: '',
    servicioCita: '',
    barbero: { id: null, nombre: '' }
}


document.addEventListener('DOMContentLoaded', function(){
    const paginaCitas= document.querySelector('.cita');
    if(paginaCitas){ 
        iniciarApp();
    }
});

function iniciarApp(){
    mostrarSeccion();
    tabs();
    botonesPaginador();
    paginaAnterior();
    paginaSiguiente();

    consultarAPI();
    consultarAPIBarberos();
    obtenerFeriados();

    nombreCliente();
    nombreClienteAdmin();
    idCliente();
    barbero();

    prevenirSubmitFormulario();
}

function mostrarSeccion(){
    const seccionAnterior = document.querySelector('.mostrar');
    if(seccionAnterior) {
        seccionAnterior.classList.remove('mostrar');
    }

    const pasoActual=document.querySelector(`#paso-${paso}`);
    pasoActual.classList.add('mostrar');

    const tabAnterior= document.querySelector('.tabs .actual');
    if(tabAnterior){
        tabAnterior.classList.remove('actual');
    }

    const tabActual= document.querySelector(`[data-paso="${paso}"]`);
    tabActual.classList.add('actual');
    if (paso === 2) {
        mostrarResumen();
    }
}


function tabs(){
    const botones= document.querySelectorAll('.tabs button');
    botones.forEach(boton => {
        boton.addEventListener('click', function(e){
            e.preventDefault();
            paso= parseInt(e.target.dataset.paso);
            mostrarSeccion();
            botonesPaginador();
        })
    });
}

function botonesPaginador(){
    const paginaAnterior= document.querySelector('#anterior');
    const paginaSiguiente= document.querySelector('#siguiente');

    if(paso===1){
        paginaAnterior.classList.add('ocultar');
        paginaSiguiente.classList.remove('ocultar');
    }else{
        paginaAnterior.classList.remove('ocultar');
        paginaSiguiente.classList.add('ocultar');
    }

    mostrarSeccion();
}

function paginaAnterior(){
    const paginaAnterior= document.querySelector('#anterior');
    paginaAnterior.addEventListener('click', function(e){
        e.preventDefault();
        if(paso<=pasoInicial) return;
        paso--;
        botonesPaginador();
    })
}

function paginaSiguiente(){
    const paginaSiguiente= document.querySelector('#siguiente');
    paginaSiguiente.addEventListener('click', function(e){
        e.preventDefault();
        if(paso>=pasoFinal) return;
        paso++;
        botonesPaginador();
    })
}

async function consultarAPI(){
    try {
        const url= '/api/servicios';
        const resultado= await fetch(url);
        const servicios= await resultado.json();
        mostrarServicios(servicios);

    } catch (error) {
        console.log(error);
    }
}

async function consultarAPIBarberos(){
    try {
        const url= '/api/barberos';
        const resultado= await fetch(url);
        let barberosAPI = await resultado.json();
        barberos = barberosAPI.map(barbero => ({
            ...barbero,
            id: Number(barbero.id) 
        }));
        
        mostrarTodosLosBarberos();

    } catch (error) {
        console.log(error);
    }
}


function mostrarServicios(servicios){
    servicios.forEach(servicio => {
        const {id, nombre, precio} = servicio;

        const nombreServicio= document.createElement('P');
        nombreServicio.classList.add('nombre-servicio');
        nombreServicio.textContent= nombre;

        const precioServicio= document.createElement('P');
        precioServicio.classList.add('precio-servicio');
        precioServicio.textContent= `$${precio}`;

        const divServicio= document.createElement('DIV');
        divServicio.classList.add('servicio');
        divServicio.dataset.idServicio= id;
        divServicio.onclick= function(){
            seleccionarServicio(servicio);
        }

        divServicio.appendChild(nombreServicio);
        divServicio.appendChild(precioServicio);
        document.querySelector('#servicios').appendChild(divServicio);
    });
}

function seleccionarServicio(servicio){
    const {id}= servicio;
    
    const servicioPrevio= document.querySelector('.seleccionado');
    if(servicioPrevio){
        servicioPrevio.classList.remove('seleccionado');
    }
    const divServicio= document.querySelector(`[data-id-servicio="${id}"]`);
    divServicio.classList.toggle('seleccionado');

    cita.servicioCita=servicio;
}

function idCliente(){
    cita.id= document.querySelector('#id').value;
}

function mostrarTodosLosBarberos() {
    const selectBarberos = document.querySelector('#barberos');
    if (!selectBarberos) return;
    if (selectBarberos.children.length > 1) {
        return; 
    }
    
    barberos.forEach(barbero => {
        const {id, nombre} = barbero;
        const opcion = document.createElement('OPTION');
        opcion.textContent = nombre;
        opcion.value = id;
        selectBarberos.appendChild(opcion);
    });
}


function barbero(){
    const selectBarberos = document.querySelector('#barberos');
    if (selectBarberos) {
        selectBarberos.addEventListener('change', seleccionarBarbero); 
    }
}

function seleccionarBarbero(e){
    const nombre = e.target.options[e.target.selectedIndex].textContent;
    let id = e.target.value;
    if(id=== ''){
        id= null;
    }

    cita.barbero = {
        id: id,
        nombre: nombre
    };
    
    validarDatosCita();
}

function nombreCliente(){
    const inputNombre = document.querySelector('#nombre');
    if (inputNombre) {
        cita.nombre = inputNombre.value; 
        inputNombre.addEventListener('input', function(e) {
            cita.nombre = e.target.value;
        });
    }
}

function nombreClienteAdmin(){
    const inputNombre = document.querySelector('#nombreClienteAdmin');
    if (inputNombre) {
        cita.nombreClienteAdmin = inputNombre.value; 
        inputNombre.addEventListener('input', function(e) {
            cita.nombreClienteAdmin = e.target.value;
        });
    }
}

function seleccionarFecha(){
    const inputDate= document.querySelector('#fecha');

    inputDate.addEventListener('change', function(e){
        e.preventDefault(); 
        
        const valorFecha = e.target.value; 
        const fechaSeleccionada = new Date(valorFecha + 'T00:00:00');
        const diaDeLaSemana = fechaSeleccionada.getUTCDay(); 
        if([0 , 1].includes(diaDeLaSemana)){
            e.target.value='';
            const inputHora = document.querySelector('#hora');
            while (inputHora.firstChild) {
                inputHora.removeChild(inputHora.firstChild);
            }
            inputHora.disabled = true;
            cita.hora = ''; 
            mostrarAlerta('Seleccione un día de martes a sábado', 'error', '.formulario');
            return;
        }

        const partesFecha = valorFecha.split('-'); 
        const AAAA = parseInt(partesFecha[0]);
        const MM = parseInt(partesFecha[1]) - 1; 
        const DD = parseInt(partesFecha[2]);
        const msFechaSeleccionada = Date.UTC(AAAA, MM, DD); 
        let esFeriado = false;
        
        feriados.forEach(feriado => {
            if(feriado.getTime() === msFechaSeleccionada){ 
                esFeriado = true;
            }
        });
        
        if(esFeriado) {
            e.target.value='';
            const inputHora = document.querySelector('#hora');
            while (inputHora.firstChild) {
                inputHora.removeChild(inputHora.firstChild);
            }
            inputHora.disabled = true;
            cita.hora = ''; 
            mostrarAlerta('El día seleccionado la barbería estará cerrada', 'error', '.formulario');
            return;
        }
        
        cita.fecha = valorFecha;
        validarDatosCita();
    })
}

function validarDatosCita() {
    const { fecha, barbero } = cita;
    const inputHora = document.querySelector('#hora');
    
    if (!fecha || !barbero.id) {
        inputHora.disabled = true;
        inputHora.value = '';
        cita.hora = '';
        while (inputHora.firstChild) {
            inputHora.removeChild(inputHora.firstChild);
        }
        if (fecha && !barbero.id) {
            mostrarAlerta('Seleccione un Barbero para ver los horarios disponibles.', 'error', '.formulario');
        }
        return;
    }

    cargarHorasEnInput(); 
}

async function cargarHorasEnInput(){
    const horasDisponibles = await obtenerHorasDisponibles();
    const inputHora= document.querySelector('#hora');
    while (inputHora.firstChild) {
        inputHora.removeChild(inputHora.firstChild);
    }
    inputHora.removeEventListener('change', seleccionarHora);

    const opcion = document.createElement('OPTION');
    opcion.value = '';
    opcion.textContent = 'Seleccionar Hora';
    opcion.disabled= true;
    inputHora.appendChild(opcion);
    
    inputHora.value = '';
    cita.hora = ''; 
    
    if(horasDisponibles.length > 0){
        horasDisponibles.forEach(hora => {
            const opcion = document.createElement('OPTION');
            opcion.value = hora;
            opcion.textContent = hora;
            inputHora.appendChild(opcion);
        });
        inputHora.disabled = false; 
        inputHora.addEventListener('change', seleccionarHora);

    } else {
        inputHora.disabled = true;
        mostrarAlerta('No hay turnos disponibles para este día con este barbero', 'error', '.formulario');
    }
}

function seleccionarHora(e){
    const horaCita = e.target.value;
    if (horaCita) {
        cita.hora = horaCita;
    } else {
        cita.hora = ''; 
    }
}

async function obtenerHorasDisponibles(){
    const diaSinCodificar= cita.fecha;
    const barberoId = cita.barbero.id;
    const url = `/api/obtener-horas?dia=${encodeURIComponent(diaSinCodificar)}&barberoId=${barberoId}`; 
    
    try {
        const respuesta = await fetch(url);
        if (!respuesta.ok) {
            console.error('Error al cargar horas disponibles:', respuesta.status);
            mostrarAlerta('Error al cargar horas disponibles. Intente más tarde.', 'error', '.formulario');
            return []; 
        }

        const horas= await respuesta.json();
        return horas;

    } catch (error) {
        console.error('Error en fetch o parseo de JSON:', error);
        mostrarAlerta('No se pudo conectar con el servidor. Intente más tarde.', 'error', '.formulario');
        return []; 
    }
}

function mostrarAlerta(mensaje, tipo, elemento, desaparece=true){
    const alertaPrevia= document.querySelector('.alerta');
    if(alertaPrevia){
        alertaPrevia.remove();
    }

    const alerta= document.createElement('DIV');
    alerta.textContent= mensaje;
    alerta.classList.add('alerta');
    alerta.classList.add(tipo);
    const referencia= document.querySelector(elemento);
    referencia.appendChild(alerta);

    if(desaparece){
        setTimeout(()=>{
            alerta.remove();
        }, 3000);
    }
}

function prevenirSubmitFormulario() {
    const formulario = document.querySelector('.formulario'); 
    if (formulario) {
        formulario.addEventListener('submit', function(e) {
            e.preventDefault(); 
            return false;
        });
        formulario.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                return false;
            }
        });
    } else {
        console.error('ERROR: El selector ".formulario" NO encontró el elemento.'); 
    }
}


function mostrarResumen() {
    const resumen=document.querySelector('.contenido-resumen');
    while(resumen.firstChild){
        resumen.removeChild(resumen.firstChild);
    }

    if(cita.fecha === '' || cita.hora === '' || typeof cita.servicioCita !== 'object' ) {
        mostrarAlerta('Faltan datos de Servicios, Fecha u Hora', 'error', '.contenido-resumen', false);

        return;
    } 
    
    const {id, nombre, nombreClienteAdmin, fecha, hora, servicioCita, barbero}= cita;

    const tituloResumen= document.createElement('H3');
    tituloResumen.classList.add('titulo-resumen');
    tituloResumen.textContent= 'Resumen Cita';
    resumen.appendChild(tituloResumen);

    const tituloServicio= document.createElement('P');
    tituloServicio.classList.add('precio-servicio-resumen');
    tituloServicio.innerHTML= `<span>Servicio:</span> ${servicioCita.nombre}`;

    const precioServicio= document.createElement('P');
    precioServicio.classList.add('precio-servicio-resumen');
    precioServicio.innerHTML= `<span>Precio:</span> $${servicioCita.precio}`;

    const resumenCita= document.createElement('DIV');
    resumenCita.classList.add('cita-resumen');
    const nombreCita= document.createElement('P');
    nombreCita.classList.add('titulo-servicio-resumen');
    nombreCita.innerHTML= `<span>Nombre: </span> ${nombre}`;

    const nombreCitaClienteAdmin= document.createElement('P');
    nombreCitaClienteAdmin.classList.add('titulo-servicio-resumen');
    nombreCitaClienteAdmin.innerHTML= `<span>Nombre del cliente: </span> ${nombreClienteAdmin}`;

    // Descomponemos la fecha guardada (YYYY-MM-DD)
    const [añoStr, mesStr, diaStr] = fecha.split('-');
    
    // El constructor de Date(Date.UTC...) usa el mes de 0 a 11, por eso restamos 1.
    const mesInt = parseInt(mesStr) - 1; 
    const diaInt = parseInt(diaStr);
    const añoInt = parseInt(añoStr);

    const fechaUTC= new Date(Date.UTC(añoInt, mesInt, diaInt));
    
    const opciones= {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC'};
    const fechaFormateada= fechaUTC.toLocaleDateString('es-MX', opciones);

    const fechaCita= document.createElement('P');
    fechaCita.classList.add('precio-servicio-resumen');
    fechaCita.innerHTML= `<span>Fecha: </span> ${fechaFormateada}`;

    const horaCita= document.createElement('P');
    horaCita.classList.add('precio-servicio-resumen');
    horaCita.innerHTML= `<span>Hora: </span> ${hora}`;

    const divBoton= document.createElement('DIV');
    divBoton.classList.add('div-boton');
    const botonReservar= document.createElement('BUTTON');
    botonReservar.classList.add('boton');
    botonReservar.type = 'button';
    botonReservar.textContent= 'Reservar Cita';
    botonReservar.onclick= reservarCita;
    divBoton.appendChild(botonReservar);

    resumenCita.appendChild(tituloServicio);
    resumenCita.appendChild(precioServicio);
    resumenCita.appendChild(nombreCita);
    if(nombreClienteAdmin !== ''){
        resumenCita.appendChild(nombreCitaClienteAdmin);
    }
    resumenCita.appendChild(fechaCita);
    resumenCita.appendChild(horaCita);
    if(barbero && barbero.nombre){
        const nombreBarbero= document.createElement('P');
        nombreBarbero.classList.add('precio-servicio-resumen');
        nombreBarbero.innerHTML= `<span>Barbero: </span> ${barbero.nombre}`;
        resumenCita.appendChild(nombreBarbero);
    }
    resumenCita.appendChild(divBoton);
    resumen.appendChild(resumenCita);
}

async function reservarCita(){
    const {nombre, nombreClienteAdmin, fecha, hora, servicioCita, id, barbero}= cita;
    const idServicio= servicioCita.id;
    const idBarbero = barbero ? barbero.id : null;
    const datos= new FormData();

    datos.append('nombreClienteAdmin', nombreClienteAdmin);
    datos.append('fecha', fecha);
    datos.append('hora', hora);
    datos.append('usuarioId', id);
    datos.append('servicio', idServicio);
    datos.append('barberoId', idBarbero);

    try {
        const url= '/api/citas';
        const respuesta= await fetch(url, {
            method: 'POST',
            body: datos
        })

        const resultado= await respuesta.json();
        if(resultado.resultado){
            Swal.fire({
                title: "Cita Reservada",
                text: "Su cita se ha reservado correctamente",
                icon: "success",
            }).then(()=> {
                if(isAdmin){
                    location.href= '/admin';
                }else{
                    location.href= '/turnos'; 
                }
            });
        }
    } catch (error) {
        Swal.fire({
            title: "Error",
            text: "Hubo un error al reservar la cita",
            icon: "error",
            });
    }
}

async function obtenerFeriados(){
    try {
        const url= '/api/obtener-feriados';
        const respuesta= await fetch(url);
        const feriadosDB = await respuesta.json(); 
        
        feriados = feriadosDB.map(objetoFeriado => {
            const partesFecha = objetoFeriado.feriado.split('-');
            const AAAA = parseInt(partesFecha[0]);
            const MM = parseInt(partesFecha[1]) - 1; 
            const DD = parseInt(partesFecha[2]);
            return new Date(Date.UTC(AAAA, MM, DD));
        });
        seleccionarFecha();
    } catch (error) {
        console.error('Error al obtener feriados:', error);
    }
}